/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import "../../styles/CertificationsDetails.scss";
import { getPersonas, getTooltipPersona } from "../../utils/util";
import { useTranslation } from "react-i18next";
import { getAssessments, getLearningPathsIdFromAssessments, getCurrentCertification } from "../../services/certification";
import { ClayTooltipProvider } from '@clayui/tooltip';
import CertificationsDetailsCard from "./CertificationsDetailsCard";

const CertificationsDetails = ({ assetId }) => {
	const [assessments, setAssessments] = useState(null);
	const [certifications, setCertifications] = useState(null);
	const [learningPaths, setLearningPaths] = useState([]);

	const {
		t,
	} = useTranslation();

	useEffect(() => {
		if(!assetId) return;

		const fetchAssessments = async () => {
			const response = await getAssessments(assetId);

			setAssessments(response);
		};

		const fetchCertifications = async () => {
			const response = await getCurrentCertification(assetId);

			setCertifications(response);
		};

		const fetchLearningPathsId = async () => {
			const response = await getLearningPathsIdFromAssessments();

			setLearningPaths(response);
		};

		fetchAssessments();
		fetchCertifications();
		fetchLearningPathsId();
	}, [assetId]);

	return (
		<>
			<div className="certification-details__banner">
				<div className="certification-details__banner-contents">
					<div className="certification-details__banner-tag-certification">
						<p>{t("certification")}</p>
					</div>

					<h1>{certifications?.name}</h1>

					<div className="certification-details__banner-tags">
						<div className="certification-details__banner-info-tag d-flex mt-3">
							{certifications &&
								<ClayTooltipProvider>
									<div className="certification-details__banner-tag-persona" data-tool-tip-align="top" title={getTooltipPersona(certifications.persona)}>
										<p></p>
										{getPersonas(certifications.persona)}
									</div>
								</ClayTooltipProvider>
							}
						</div>
					</div>
				</div>
			</div>

			<div className="certifications-details__main">
				<div className="certifications-details__main-title">
					<h1>{t("required-assessments")}</h1>
					{certifications &&
						<p>{t("description-assessments-certifications" , 
						{certificationsName: certifications.name})}</p>
					}
				</div>

				{assessments && assessments.length > 0 && learningPaths && learningPaths.length > 0 && (
					<>
						{assessments.map((assessment) => (
							<li key={assessment.id}>
								<CertificationsDetailsCard
										duration={assessment.durationMinutes}
										title={assessment.title}
										description={assessment.description}
										learningPaths={learningPaths}
										assessmentId={assessment.id}
										url={assessment.url}
								/>
							</li>
						))}
					</>
				)}
			</div>
		</>
	);
}

export default CertificationsDetails;